import type {VNode} from 'snabbdom';

export enum THEME {
  CONFIRM = `confirm`,
  INFO = `info`,
  DELETE = `delete`,
  WARN = `warn`,
}

export interface ConfirmAttrs {
  /** whether to hide the cancel button or not */
  'hide-cancel-button'?: boolean;
  /** label for the cancel button */
  'cancel-button-label'?: string;
  /** mp-modal closeable (x in top right) */
  closeable?: boolean;
  /** whether to disable the confirm button or not */
  'confirm-button-disabled'?: boolean;
  /** label for the confirm button */
  'confirm-button-label'?: string;
  /** whether the modal is open or not */
  open?: boolean;
  /** title at the top of the modal */
  title?: string;
  /** text in the body of the modal */
  description?: string;
  /** allow escape newlines in the description text */
  'description-allow-newline'?: boolean;
  /** modal theme (e.g. delete) */
  theme?: THEME;
  /** include an input field in the modal */
  'show-input'?: boolean;
  /** current string value of the input field */
  'initial-input-value'?: string;
  /** allows input field to be empty to submit */
  'allow-empty-input-value'?: boolean;
  /** the string value for test reference */
  elref?: string;
}

export type ValidatorFn = (inputValue: string) => string | null;

export interface ConfirmProps {
  inputValidator?: ValidatorFn;
  bannerContent?: VNode;
}
